<template>
    <div class="md-layout">
      <!-- Label and Month Autocomplete -->
      <div class="label-and-autocomplete">
        <label>{{ label }}</label>
        <ValidationProvider :rules="monthRules" :vid="prefixLabel + ' ' + label + ' Month'" immediate v-slot="{ failed }">
          <md-autocomplete
            class="auto-complete"
            v-model="month"
            :md-options="months"
            md-input-placeholder="MM"
            @md-selected="onChangeInput()"
            @md-changed="onChangeInput()"
            @keydown.40.stop.prevent.native
            @keydown.38.stop.prevent.native
          />
          <span v-if="failed" class="error-msg">{{ label }} month is not valid</span>
        </ValidationProvider>
      </div>
      <ValidationProvider :rules="yearRules" :vid="prefixLabel + ' ' + label + ' Year'" immediate v-slot="{ failed }">
        <!-- Year Autocomplete -->
          <md-autocomplete
            class="auto-complete"
            v-model="year"
            :md-options="years"
            md-input-placeholder="YYYY"
            @md-selected="onChangeInput()"
            @md-changed="onChangeInput()"
            @keydown.40.stop.prevent.native
            @keydown.38.stop.prevent.native
          />
          <span v-if="failed" class="error-msg">{{ label }} year is not valid</span>
      </ValidationProvider>
      </div>
</template>


<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    errormsg: {
      type: String,
      default: "Please enter the correct information."
    },
    prefixLabel: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      years: [],
      month: null,
      year: null
    }
  },
  methods: {
    onChangeInput() {
      this.$emit('monthYearSelect', {
        month: this.month,
        year: this.year
      });
    },
    getMomentValue() {
      if (typeof this.value === 'string') {
        const date = moment(this.value);
        if (date.isValid()) {
          return date;
        }
      }
      return null;
    },
    getRules(field){
      let rules = [];
      if(this.required) rules.push('required');

      if (field === 'month' && this.isMonthUsed) {
        // Month Autocomplete Rules
        rules.push('integer');
        rules.push("min_value:1")
        rules.push("max_value:12")
      }

      if (field === 'year' && this.isYearUsed) {
        // Year Autocomplete Rules
        rules.push('integer');
        rules.push("min_value:1960")
        rules.push(`max_value:${new Date().getFullYear()}`)
      }
        return rules.join('|');
    },
    refreshValue() {
      let date = this.getMomentValue()
      if (date) {
        this.month = date.format('MM')
        this.year = date.format('YYYY')
      } else {
        this.month = null
        this.year = null
      }
    }
  },
  mounted() {
    this.refreshValue();
    const currentYear = new Date().getFullYear();
    const startYear = 1960;

    this.years = Array.from({length: currentYear - startYear + 1}, (value, index) => (currentYear - index).toString());
 },
 computed: {
    isMonthUsed() {
      return this.month !== null;
    },
    isYearUsed() {
      return this.year !== null;
    },
    monthRules() {
      return this.getRules('month');
    },
    yearRules() {
      return this.getRules('year');
    }
  }
}
</script>
<style lang="scss" scoped>

  .md-layout {
    height: 100%;
    flex-wrap: nowrap;
    justify-content: center;
    display: flex;
  }

  .auto-complete {
    padding: 0px;
    height: 38px;
  }

  .label-and-autocomplete {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    margin-right: 3px;
  }

  .label-and-autocomplete label {
    margin-bottom: 0px;
    position: absolute;
    top: -0.6rem;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: 400;
    font-family: Helvetica, arial, sans-serif;
    padding: 0px;
  }

  .error-message {
    color: red;
    padding: 6px;
    margin: 15px 30px;
    text-align: center;
  }

</style>